export function getClientData() {
  let cookies: any = document.cookie || "";
  if (!cookies) return "";
  cookies = cookies.split(";") as unknown as object;

  let cookieObj: any = {};
  for (let i = 0; i < cookies.length; i++) {
    if (cookies[i].includes("electronicshop-user_x_token_user_x_t_fg_p_r")) {
      cookieObj.token = cookies[i];
    }
  }
  let userString = cookieObj.token;
  if (typeof userString === "undefined")
    return JSON.stringify({ firstName: "" });

  userString = userString.split("=")[1] || JSON.stringify({ none: "user" });
  return JSON.parse(userString);
}
